import { createRouter, createWebHistory } from 'vue-router'
import config from '@/utils/config'

const routes = [
  {
    path: '/',
    component: () => import('../views/index.vue'),
    meta: {
      title: '江西长勤信息技术有限公司'
      // title: '长勤组织数智化运营管理平台'
    },
  },
  {
    path: '/index',
    component: () => import('../views/index.vue'),
    meta: {
      title: '江西长勤信息技术有限公司'
      // title: '长勤组织数智化运营管理平台'
    },
  },
  {
    path: '/digitization',
    component: () => import('../views/digitization.vue'),
    meta: {
      title: '长勤数智化'
    }
  },
  {
    path: '/travel',
    component: () => import('../views/travel.vue'),
    meta: {
      title: '长勤差旅'
    }
  },
  {
    path: '/mall',
    component: () => import('../views/mall.vue'),
    meta: {
      title: '积分商城'
    }
  },
  {
    path: '/intelligent',
    component: () => import('../views/intelligent.vue'),
    meta: {
      title: '长勤智采'
    }
  },
  {
    path: '/starpoint',
    component: () => import('../views/starpoint.vue'),
    meta: {
      title: '星点广告投放'
    }
  },
  {
    path: '/case',
    component: () => import('../views/case.vue'),
    meta: {
      title: '客户案例'
    }
  },
  {
    path: '/about',
    component: () => import('../views/about.vue'),
    meta: {
      title: '关于长勤'
    }
  },
  {
    path: '/information',
    component: () => import('../views/information.vue'),
    meta: {
      title: '企业资讯'
    }
  },
  {
    path: '/article',
    component: () => import('../views/article.vue'),
    meta: {
      title: '资讯详情'
    }
  },
  {
    path: '/download',
    component: () => import('../views/download.vue'),
    meta: {
      title: '软件下载'
    },
  },
]

const router = createRouter({
  //history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes,
  scrollBehavior(savedPosition) {
    window.scrollTo(savedPosition.x, savedPosition.y)
  }
})

router.beforeEach((to, from, next) => {
  //判断是否PC版
  // phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone
  let flag = window.navigator.userAgent.match(/(phone|pod|iPhone|iPod|Android|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  if (flag) {
    //非PC端跳到H5页面(判断测试或正式)
    if(config.host_state){
      window.location.href = 'http://h5.changqinos.com/'  //正式
    }else{
      window.location.href = 'http://cq-web-h5.52shanglu.com/'  //测试
    }
  }else{
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  }
})

export default router
